/**
 * The host's per-cast execution limits, in a leaf module: legality contexts read them without importing the runtime,
 * which itself imports the legality layer.
 */
export interface ExecutionLimits {
  maxEvents: number;
  maxSpawnedAttacks: number;
  maxProcGeneration: number;
}

/** The same numbers as `SVP_0_1.limits` (`test/execution-limits-profile.test.ts` holds them equal), written here so the runtime's defaults do not depend on a mutable profile object. */
export const DEFAULT_EXECUTION_LIMITS: ExecutionLimits = {
  maxEvents: 64,
  maxSpawnedAttacks: 32,
  maxProcGeneration: 3,
};
